import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import AverageStars from 'components/common/average-stars/AverageStars'
import { hasLocizeTranslation } from 'lib/utils/locize'
import clsx from 'clsx'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import Coachmark from 'components/common/coachmark'
import { COACHMARK_POSITION } from 'components/common/coachmark/const'
import { RATING_FIT_VALUES_ENUM } from 'components/pdp/const'
import { BUTTON_TYPES } from 'constants/button'
import Button from 'components/common/button'
import styles from './product-reviews-average-ratings.scss'
import ReviewsRatings from './reviews-ratings/ReviewsRatings'
import { segmentPdpGoToOrdersClicked } from '../../pdp-reviews-segment/pdpReviewsSegment'

const ProductReviewsAverageRatings = ({
  t,
  isPhone,
  productId,
  productAverageRatings,
}) => {
  const productFitsCoachMarkRef = useRef(null)
  const [isOpenCoachmark, setIsOpenCoachmark] = useState(false)
  const handleOnClickGoToOrders = () => {
    segmentPdpGoToOrdersClicked({
      id_product: productId,
    })
  }

  return (
    <div
      data-cy="product-reviews-average-ratings-container"
      className="product-reviews-average-ratings-container"
    >
      <style jsx>{styles}</style>
      <div className="reviews-average-fit-wrapper">
        <div className="reviews-average-fit">
          <div className="reviews-average">
            <div className={clsx(Typo.title2)}>
              {productAverageRatings?.avg_overall_product_rating}
            </div>
            <AverageStars
              averageRating={productAverageRatings?.avg_overall_product_rating}
            />
          </div>
          <div className="reviews-fit">
            <div style={{ display: 'flex', gap: '4px' }}>
              <div className={clsx(Typo.body2)}>
                {hasLocizeTranslation(t, 'FIT', 'Fit')}
              </div>
              <div>
                <Icon
                  alt="product fit info"
                  src={ICONS.info}
                  size={ICON_SIZE.small}
                  onClick={() => setIsOpenCoachmark(true)}
                />
                <Coachmark
                  onClose={() => setIsOpenCoachmark(false)}
                  position={COACHMARK_POSITION.TOP_RIGHT}
                  text={hasLocizeTranslation(
                    t,
                    'PRODUCT_FITS_COACHMARK',
                    'How well the product fits, does it match the provided sizing information accurately?',
                  )}
                  isOpen={isOpenCoachmark}
                  customContainerProps={{
                    style: {
                      right: '-16px',
                      top: '12px',
                      width: '1600%',
                      overflowWrap: 'break-word',
                      whiteSpace: 'normal',
                      textAlign: 'left',
                    },
                  }}
                  disableLeaveListener
                  disableEnterListener
                  customChildrenRef={productFitsCoachMarkRef}
                />
              </div>
            </div>
            <div className="reviews-fit__wrapper">
              <div className="reviews-fit__path" />
              <div className="reviews-fit__circles">
                <div
                  className={clsx(
                    'reviews-fit__circle-wrapper',
                    'reviews-fit__circle-wrapper__loose',
                  )}
                >
                  <div
                    data-cy="reviews-fit__circle"
                    className={clsx('reviews-fit__circle', {
                      'reviews-fit__circle__selected':
                        productAverageRatings?.avg_rating_true_to_size ===
                        RATING_FIT_VALUES_ENUM.LOOSE,
                    })}
                  />
                  <div className={clsx(Typo.body2)}>
                    {hasLocizeTranslation(t, 'LOOSE', 'Loose')}
                  </div>
                </div>
                <div
                  className={clsx(
                    'reviews-fit__circle-wrapper',
                    'reviews-fit__circle-wrapper__true-to-size',
                  )}
                >
                  <div
                    data-cy="reviews-fit__circle"
                    className={clsx('reviews-fit__circle', {
                      'reviews-fit__circle__selected':
                        productAverageRatings?.avg_rating_true_to_size ===
                        RATING_FIT_VALUES_ENUM.TRUE_TO_SIZE,
                    })}
                  />
                  <div className={clsx(Typo.body2)}>
                    {hasLocizeTranslation(t, 'TRUE_TO_SIZE', 'True to size')}
                  </div>
                </div>
                <div
                  className={clsx(
                    'reviews-fit__circle-wrapper',
                    'reviews-fit__circle-wrapper__tight',
                  )}
                >
                  <div
                    data-cy="reviews-fit__circle"
                    className={clsx('reviews-fit__circle', {
                      'reviews-fit__circle__selected':
                        productAverageRatings?.avg_rating_true_to_size ===
                        RATING_FIT_VALUES_ENUM.TIGHT,
                    })}
                  />
                  <div className={clsx(Typo.body2)}>
                    {hasLocizeTranslation(t, 'TIGHT', 'Tight')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!isPhone && (
          <div className={clsx('product-reviews-go-to-orders')}>
            <span className={Typo.caption}>
              {hasLocizeTranslation(t, 'BOUGHT_THIS_ITEM', 'Bought this item?')}{' '}
              {hasLocizeTranslation(
                t,
                'PRODUCT_REVIEWS_GO_TO_ORDERS',
                'Go to your orders history to write a review.',
              )}
            </span>
            <Button
              style={{ color: '#000' }}
              target="_blank"
              type={BUTTON_TYPES.link}
              link
              aProps={{ href: '/user/orders' }}
              onClick={handleOnClickGoToOrders}
            >
              {hasLocizeTranslation(t, 'CLICK_HERE', 'Click Here!')}
            </Button>
          </div>
        )}
      </div>
      <ReviewsRatings productAverageRatings={productAverageRatings} />
      {isPhone && (
        <div className={clsx('product-reviews-go-to-orders')}>
          <span className={Typo.caption}>
            {hasLocizeTranslation(t, 'BOUGHT_THIS_ITEM', 'Bought this item?')}{' '}
            {hasLocizeTranslation(
              t,
              'PRODUCT_REVIEWS_GO_TO_ORDERS',
              'Go to your orders history to write a review.',
            )}
          </span>
          <Button
            style={{ color: '#000', height: 'auto' }}
            target="_blank"
            type={BUTTON_TYPES.link}
            link
            aProps={{ href: '/user/orders' }}
            onClick={handleOnClickGoToOrders}
          >
            {hasLocizeTranslation(t, 'CLICK_HERE', 'Click Here!')}
          </Button>
        </div>
      )}
    </div>
  )
}

ProductReviewsAverageRatings.propTypes = {
  // component props
  productId: PropTypes.number.isRequired,
  productAverageRatings: PropTypes.shape({
    avg_design_and_style_rating: PropTypes.number,
    avg_overall_product_rating: PropTypes.number,
    avg_product_as_display_rating: PropTypes.number,
    avg_product_quality_rating: PropTypes.number,
    avg_rating_true_to_size: PropTypes.string,
    total_count: PropTypes.number,
  }).isRequired,

  // redux props
  t: PropTypes.func.isRequired,
  isPhone: PropTypes.bool.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
    productSalesCount: state.product?.payload?.sales_count,
  })),
  withI18next(),
)(ProductReviewsAverageRatings)
